export const SAVE_DKW = 'save_dkw';
export const LOAD_TOP_HOSPITALS = 'load_top_hospitals';
